import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

interface WhatsAppButtonProps {
  whatsAppLink: string;
  enabled: boolean;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ whatsAppLink, enabled }) => {
  if (!enabled) {
    return null;
  }

  const handleClick = () => {
    window.open(whatsAppLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Contact us on WhatsApp" placement="left">
      <Fab
        color="primary"
        aria-label="WhatsApp"
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1000,
          backgroundColor: '#25D366', // WhatsApp green
          '&:hover': {
            backgroundColor: '#128C7E', // Darker green on hover
          },
          '@media (max-width: 600px)': {
            bottom: 70, // Position above mobile bottom nav (60px + 20px margin)
            right: 16,
            width: 56,
            height: 56,
          },
        }}
      >
        <WhatsAppIcon sx={{ color: 'white', width: 36, height: 36 }} />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;
